import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form } from 'redux-form';
import { cutBranch } from 'appSrc/utils/tree';
import { PrimaryButton, DLRichTextEditor } from 'appSrc/components/UI';
import { FormTextField, FormSelect } from 'appSrc/components/UI/ReduxForm';
import CategorySelectModal from './Select';
import style from './styles/style.module.css';

class CategoryForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.parentId = this.props.initialValues.parent_id;
        var parent = null;
        if( this.parentId !== null ) {
            var branch = cutBranch( this.props.categoryTree, this.parentId );
            parent = branch[ branch.length - 1 ];
            this.branch = branch;
        }

        this.state = {
            headingText: this.props.initialValues.heading || '',
            showCategorySelect: false,
            parent: parent,
        };
    }
    updateHeading = ( newText ) => {
        this.setState( { headingText: newText } );
    }
    updateParent = ( { data } ) => {
        var newParent = data[ 0 ] || null;
        this.parentId = newParent ? newParent.id : null;
        if( this.parentId !== null ) {
            var branch = cutBranch( this.props.categoryTree, this.parentId );
            this.branch = branch;
        } else {
            this.branch = undefined;
        }

        this.setState( {
            parent: newParent,
            showCategorySelect: false,
        } );
    }
    submit = ( values ) => {
        values = { ...values };
        values.heading = this.state.headingText;
        values.parent_id = this.parentId || undefined;
        this.props.onSubmit( values );
    }
    render() {
        const { handleSubmit } = this.props;
        const { headingText, parent } = this.state;
        return (
            <div className={ style.categoryForm } >
                <Form onSubmit={ handleSubmit( this.submit ) }>
                    <Field
                    name="name"
                    label="Name"
                    component={ FormTextField }
                    fullWidth />

                    <div className={ style.parentField }>
                        <div className={ style.fieldTitle }>Parent:</div>
                        <div className={ style.fieldInput }
                        onClick={ () => { this.setState( { showCategorySelect: true } ); } }>
                            { parent && parent.name }
                        </div>
                    </div>

                    <DLRichTextEditor label='Heading Text:'
                    value={ headingText } onChange={ this.updateHeading } />

                    <Field
                    name='status'
                    label='Status'
                    component={ FormSelect }
                    options={ [
                        { text: 'Draft', value: 'draft' },
                        { text: 'Published', value: 'published' },
                    ] } />

                    <PrimaryButton
                    label="Submit"
                    fullWidth
                    type="submit"
                    style={ { marginTop: '15px' } }/>
                </Form>
                { this.state.showCategorySelect &&
                    <CategorySelectModal initialValues={ parent && [ parent ] }
                    defaultOpen={ this.branch && this.branch.map( leaf => leaf.id ) }
                    hideOptions={ [ this.props.initialValues.id ] }
                    onSubmit={ this.updateParent } singleSelect
                    closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                }
            </div>
        );
    }
}

CategoryForm = reduxForm( {
    form: 'CategoryForm',
} )( CategoryForm );


const mapStateToProps = ( state ) => {
    return {
        categoryTree: state.vars.admin.categoryTree,
    };
};

export default connect( mapStateToProps )( CategoryForm );
